// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CtsGantryEventSelectionModel } from '../../model/cts-gantry-event-selection-model';
import { CtsGantryInitEvent } from '../../interfaces/cts-gantry-init-event';
import { CtsGantryLogData } from '../../interfaces/cts-gantry-log-data';
import { CtsGantryCacheModel } from '../../model/cts-gantry-cache-model';
import { CtsGantryStartupPaneComponent } from '../cts-gantry-startup-pane/cts-gantry-startup-pane.component';
import { CtsGantryLogTableComponent } from '../cts-gantry-log-table/cts-gantry-log-table.component';
import { SystemDetailsModel } from 'src/app/api/remote-api/.portal.generated/models';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    CtsGantryStartupPaneComponent,
    CtsGantryLogTableComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-cts-gantry-init',
  templateUrl: './cts-gantry-init.component.html',
  styleUrl: './cts-gantry-init.component.scss',
})
export class CtsGantryInitComponent {
  @Input({ required: true }) selectionModel =
    new CtsGantryEventSelectionModel();
  @Input({ required: true }) logCacheModel =
    new CtsGantryCacheModel<CtsGantryLogData>();
  @Input({ required: true }) selectedEvent: CtsGantryInitEvent | undefined;
  @Input({ required: true }) events: CtsGantryInitEvent[] = [];
  @Input({ required: true }) systemDetails!: SystemDetailsModel;
  @Output() selectedEventChange = new EventEmitter<CtsGantryInitEvent>();

  protected onSelectedEventChange(sEvent: CtsGantryInitEvent): void {
    this.selectedEvent = sEvent;
    this.selectedEventChange.emit(sEvent);
  }
}
